const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/analyze/users.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
// Admin Analyze Users Layout
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/analyze/users")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    search: z.string().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Users",
      description: "Page title"
    })
  }
});